const getFiles = state => state.files;
const getCountFiles = state => state.countFiles;
const getFilesInClient = state => state.filesInClient


export default {
  getFiles,
  getCountFiles,
  getFilesInClient,
};



// WEBPACK FOOTER //
// ./src/store/modules/files/getters.js